import { defineComponent as _defineComponent } from 'vue'
import { computed } from '@nuxtjs/composition-api';
import ResourceTags from '~/components/resource/ResourceTags.vue';
import { CardData } from '~/composables/useCardData';
import { readingTime } from '~/utils/formatText';
import { defaultThumbnailOnError } from '~/utils/image';


export default /*#__PURE__*/_defineComponent({
  __name: 'CardFooter',
  props: {
    item: null,
    showAuthor: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  item: CardData;
  showAuthor?: boolean;
};



const defaultIcon = computed(() => {
  return `https://api.dicebear.com/7.x/initials/svg?seed=${props.item.author?.display_name}&backgroundColor=FFA361,FB6F3F,C7CDFF,F0DEFF,BDD486,EADFD8&radius=50`;
});

const isBlogOrPodcast = computed(
  () => props.item.postType === 'blog' || props.item.postType === 'podcast'
);

return { __sfc: true,props, defaultIcon, isBlogOrPodcast, ResourceTags, readingTime, defaultThumbnailOnError }
}

})